export default {"src":"/_next/static/media/zhk-gray-sm.f756a0df.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};